import { MutableRefObject } from "react";
import { Map, MapLayerEventType, MapLayerMouseEvent } from "maplibre-gl";
import {
  PlanningBlocks,
  Schools,
} from "../../../../editing_planning/data_requirements";
import { EDIT_LAYERS, MAP_LAYERS } from "../constants";
import {
  EditingContextStore,
  useEditingContextStoreRef,
} from "../../../../context/EditingContext";
import { hoverSchool, unhoverSchool } from "../eventHandlers";

const getEditingEventHandlers = (
  map: MutableRefObject<Map>,
  editingContextStore: MutableRefObject<EditingContextStore>,
  blocks: PlanningBlocks,
  schools: Schools,
): {
  eventType: keyof MapLayerEventType;
  handler: (e?: MapLayerMouseEvent) => void;
  layer?: string;
}[] => {
  const handleClick = (e: MapLayerMouseEvent) => {
    editingContextStore.current.handleClick(e, blocks, schools);
  };
  const handleMouseMove = (e: MapLayerMouseEvent) => {
    map.current.getCanvas().style.cursor = "pointer";
    editingContextStore.current.handleHoveredBlock(
      e.features[0].properties.pb_id,
      blocks,
      schools,
    );
  };
  const handleMouseLeave = () => {
    map.current.getCanvas().style.cursor = "";

    editingContextStore.current.handleHoveredBlock(undefined);
  };
  return [
    {
      eventType: "mouseenter",
      layer: MAP_LAYERS.schoolPoints,
      handler: (e) => hoverSchool(e, map),
    },
    {
      eventType: "mouseleave",
      layer: MAP_LAYERS.schoolPoints,
      handler: () => unhoverSchool(map),
    },
    { eventType: "click", handler: handleClick },
    { eventType: "mousemove", handler: handleMouseMove },
    { eventType: "mouseleave", handler: handleMouseLeave },
  ];
};

export const useEnableEditMode = () => {
  const editingContextStore = useEditingContextStoreRef();
  return (
    map: MutableRefObject<Map>,
    blocks: PlanningBlocks,
    schools: Schools,
  ) => {
    const eventHandlers = getEditingEventHandlers(
      map,
      editingContextStore,
      blocks,
      schools,
    );
    EDIT_LAYERS.forEach((layer) => {
      map.current.setLayoutProperty(layer, "visibility", "visible");
    });

    eventHandlers.forEach((event) => {
      map.current.on(
        event.eventType,
        event?.layer ?? MAP_LAYERS.swappableBlocks,
        event.handler,
      );
    });

    return () => {
      EDIT_LAYERS.forEach((layer) => {
        map.current.setLayoutProperty(layer, "visibility", "none");
      });
      eventHandlers.forEach((event) => {
        map.current.off(
          event.eventType,
          MAP_LAYERS.swappableBlocks,
          event.handler,
        );
      });
    };
  };
};
